import TransactionsListComponent from "../transactions-list.component";
import TransactionType from "@homegame/common/dist/enum/transaction-type.enum";
import Grid from "@mui/material/Grid";
import { useAuth } from "../../core/context/auth.context";
import { useNavigate } from "react-router-dom";
import useScreenSize from "../../core/hooks/use-screen-size";
import useUserOs from "../../core/hooks/use-user-os";

export default function TabReceived() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const screenSize = useScreenSize();
  const { isIOS } = useUserOs();

  const innerContainerSize = screenSize.height - (isIOS ? 240 : 225); // magic numbers

  const onTransactionStatusChanged = () => {
    navigate(0);
  };

  return (
    <Grid item xs={12} height="80vh">
      <TransactionsListComponent
        height={innerContainerSize}
        pageSize={Math.floor((innerContainerSize - 100) / 80)}
        showTableName
        filters={{
          type: [TransactionType.PAYMENT],
          userId: user?.id,
        }}
        onActionDone={onTransactionStatusChanged}
      />
    </Grid>
  );
}
